import { DollarSignIcon } from 'lucide-react';

import type { RouteListItem } from '@/types';

export const accountReceivablesSubNav: RouteListItem[] = [
  {
    path: '/account-receivables/$id',
    icon: DollarSignIcon,
    name: 'Accounts Receivable',
  },
];
